import { FC } from 'react';

import { useQuery } from '@tanstack/react-query';

import { useTutorial } from '@/hooks';
import { airesFilesIsEmptyQuery } from '@/query';

import styles from './styles.module.scss';

import TutorialIcon from '@/assets/icons/tutorial.svg?react';

export const TutorialLauncher: FC = () => {
  const { startTutorial } = useTutorial();
  const { data, isLoading } = useQuery(airesFilesIsEmptyQuery());

  if (isLoading || data?.result?.isEmpty !== false) {
    return null;
  }

  return (
    <div className={styles.launcher}>
      <button type="button" className={styles.startBtn} onClick={startTutorial}>
        <TutorialIcon /> Start tutorial
      </button>
    </div>
  );
};
